<template lang="pug">
div(class="w-100 d-flex flex-column p-2" style="height:90vh;overflow-y: auto; gap: 1rem;")
    div(v-if="!loading && !error" )
        pinned-announcement(:pinned="pinned" :showModal.sync="showModal"  @update:selectedAnnouncement="showModalAnnouncement")
                        
        div(class="d-flex flex-column w-100 h-fit  mt-4 px-2" style="overflow-y: auto; gap: 0.5rem;")
            div(class="d-flex w-100 justify-content-between align-items-center")
                h6(class="text-nowrap m-0 title-name") Announcements 
                b-form-input(type="month" v-model="selectedMonth" class=" form-input-month" @change="monthsSelected")
            div(v-if="!reloading")
                div(v-for="announcement in announcements" :key="announcement.crb5c_fowannouncementid" class="d-flex shadow-md card-announcement flex-column p-3 border-2 my-2" style="background-color: #fff; gap: 1rem;")
                    div
                        h5.my-2(v-if="announcement.subscriptionData?.type === 'acknowledgment_required' && !announcement.subscriptionData?.isSubscribed" class="text-danger font-weight-bold") IMPORTANT: PLEASE READ
                    div(class="d-flex w-100 justify-content-between mt-2")
                        h6 {{announcement.crb5c_title}} 
                            span(v-if=" announcement?.crb5c_expiry && new Date(announcement?.crb5c_expiry) < new Date()" class="badge badge-danger") Expired Pinned
                            span(v-if="announcement.subscriptionData?.type === 'acknowledgment_required' && announcement.subscriptionData?.isSubscribed" class="badge badge-success ml-2") Acknowledged
                            span(v-if="announcement.subscriptionData?.type === 'acknowledgment_required' && !announcement.subscriptionData?.isSubscribed" class="badge badge-warning ml-2") Needs Acknowledgment
                        p(class="date-announcement") {{new Date(announcement.createdon).toLocaleDateString()}}
                    div(v-html="truncateText(processAnnouncementBody(announcement.crb5c_body), 200)")
                    div(class="d-flex w-100 align-items-center justify-content-between")
                        div(class="d-flex align-items-center")
                            p(class="view-more m-0 p-0" @click="handleReadMore(announcement)") Read More
                            b-icon(icon="chevron-right")
                        b-button(v-if="announcement.subscriptionData?.type === 'acknowledgment_required' && !announcement.subscriptionData?.isSubscribed" 
                                 size="sm" variant="success" @click="openSubscriptionModal(announcement)") 
                            | Acknowledge
            div(v-else class="d-flex w-100 mt-5 h-100 justify-content-center align-items-center")
                span(class="spinner-border text-primary")
            div(v-if="announcements.length === 0" class="d-flex w-100 h-100 justify-content-center align-items-center")
                h6(class="mt-5") No Announcements Found

        b-modal(v-model="showModal" title="Announcement" size="is-large" scrollable)
            div(class="d-flex flex-column w-100")
                div(class="d-flex mb-4 flex-column w-100 justify-content-between mt-2")
                    h5 {{selectedAnnouncement?.crb5c_title}}
                    p(class="date-announcement") {{new Date(selectedAnnouncement?.createdon).toLocaleDateString('en-GB')}}
                div(class="image-gallery-container d-flex w-100 flex-column" v-if="selectedAnnouncement?.crb5c_images?.images?.length > 0" )
                    div(class="img-cont" v-for="image in selectedAnnouncement?.crb5c_images?.images" :key="image?.id")
                        img(:src="image?.url" class="w-100" alt="announcement image")
                        b-button(v-if="selectedAnnouncement?.crb5c_images?.imageDownloadable" @click="saveToDevice(image?.url)" variant="primary" class="mt-2") 
                            b-icon(icon="download")
                div(v-html="processAnnouncementBody(selectedAnnouncement?.crb5c_body)" class="mt-4")
                            
                    
                    
            template(v-slot:modal-footer)
                b-button(class="button is-success" @click="showModal = false") Close
    
    b-modal(v-model="showSubscriptionModal" hide-header hide-footer size="lg" centered body-class="p-0")
        div(v-if="selectedSubscription" class="subscription-modal")
            div(class="modal-header-custom d-flex justify-content-between align-items-center")
                div(class="d-flex align-items-center")
                    div(class="subscription-icon-large d-flex align-items-center justify-content-center")
                        b-icon(icon="card-checklist" font-scale="1.5")
                    div(class="ml-3")
                        h4(class="mb-1 text-white") {{selectedSubscription?.crb5c_title}}
                        div(class="d-flex align-items-center")
                            small(class="text-white-50 mr-2") Special Announcement
                            //- span(v-if="selectedSubscription?.subscriptionData?.isSubscribed" class="badge badge-success") 
                            //-     | ✓ Acknowledged
                b-button(variant="link" class="btn-close-custom p-2" @click="closeSubscriptionModal")
                    b-icon(icon="x" font-scale="1.2")
            
            div(class="modal-body-custom")
                div(class="description-section mb-4")
                    div
                        h5.my-2(v-if="!selectedSubscription?.subscriptionData?.isSubscribed" class="text-danger font-weight-bold") IMPORTANT: PLEASE READ
                        
                    div(v-html="processAnnouncementBody(selectedSubscription?.crb5c_body)" class="mt-2")
                div(class="details-grid mb-4")
                    div(class="detail-item")
                        div(class="detail-icon")
                            b-icon(icon="calendar" variant="primary")
                        div
                            div(class="detail-label") Created
                            div(class="detail-value") {{formatDate(selectedSubscription?.createdon)}}
                    
                    //- div(class="detail-item")
                    //-     div(class="detail-icon")
                    //-         b-icon(icon="currency-dollar" variant="success")
                    //-     div
                    //-         div(class="detail-label") Cost
                    //-         div(class="detail-value") Free
                            
                    div(class="detail-item")
                        div(class="detail-icon")
                            b-icon(:icon="selectedSubscription?.subscriptionData?.isSubscribed ? 'check-circle-fill' : 'exclamation-circle-fill'" 
                                   :variant="selectedSubscription?.subscriptionData?.isSubscribed ? 'success' : 'warning'")
                        div
                            div(class="detail-label") Status
                            div(class="detail-value" :class="selectedSubscription?.subscriptionData?.isSubscribed ? 'text-success' : 'text-warning'") 
                                | {{selectedSubscription?.subscriptionData?.isSubscribed ? 'Acknowledged' : 'Needs Acknowledgment'}}
            div(v-if="!selectedSubscription?.subscriptionData?.isSubscribed").my-2.mx-3
                span.my-3.text-muted Please read and mark this checkbox before tapping on Acknowledge.
                b-form-checkbox.my-3(v-model="tcAcknowledgement") 
                    | I acknowledge that I have read and understood this announcement.

                b-form-checkbox.my-2(class="flex-fill text-muted" v-model='sendEmailCopy' ) Send a copy to email (Optional)

                div(v-if="sendEmailCopy" class="w-100 mt-2 mb-3")
                    b-form-input(
                        v-model="recipientEmail"
                        type="email"
                        placeholder="Enter your email address"
                        :state="emailValidation"
                        size="sm"
                    )
                    b-form-invalid-feedback(:state="emailValidation")
                        | Please enter a valid email address
                    small.text-muted(v-if="caregiverEmail && !recipientEmail") Default (Registered Email): {{ caregiverEmail }}
                
            div(class="modal-footer-custom")
                b-button(variant="outline-secondary" @click="closeSubscriptionModal") 
                    | Close
                b-button(v-if="!selectedSubscription?.subscriptionData?.isSubscribed" 
                          variant="success" @click="acknowledgeSubscription" :disabled="acknowledging || !tcAcknowledgement || (sendEmailCopy && !isValidEmail)") 
                    span(v-if="acknowledging")
                        b-spinner(small) 
                        | &nbsp;Processing...
                    span(v-else) 
                        | Yes, Acknowledge
                div(v-else class="acknowledged-status d-flex align-items-center")
                    div
                        b-icon(icon="check-circle-fill" variant="success" class="mr-2")
                            span(class="text-success font-weight-bold") Acknowledged

            div(class="modal-footer-custom" v-if="selectedSubscription?.subscriptionData?.isSubscribed")
                div(v-if="!showEmailInputAfterAck")
                    b-button(variant="outline-primary" size="sm" @click="showEmailInputAfterAck = true" block)
                        b-icon(icon="envelope" class="mr-2")
                        | Send Copy to Email
                
                div(v-else class="w-100")
                    b-form-input(
                        v-model="recipientEmailAfterAck"
                        type="email"
                        placeholder="Enter your email address"
                        :state="emailValidationAfterAck"
                        size="sm"
                        class="mb-2"
                    )
                    b-form-invalid-feedback(:state="emailValidationAfterAck")
                        | Please enter a valid email address
                    small.text-muted.d-block.mb-2(v-if="caregiverEmail && !recipientEmailAfterAck") Default: {{ caregiverEmail }}
                    div(class="d-flex gap-2")
                        b-button(variant="outline-secondary" size="sm" @click="cancelEmailAfterAck" class="flex-fill")
                            | Cancel
                        b-button(variant="primary" size="sm" @click="sendEmailAfterAcknowledgement" 
                                :disabled="sendingEmailAfterAck || !isValidEmailAfterAck" class="flex-fill")
                            span(v-if="sendingEmailAfterAck")
                                b-spinner(small)
                                | &nbsp;Sending...
                            span(v-else)
                                | Send Email
                    
                    
                    
                        
    div(v-if="loading" class="d-flex w-100 h-100 flex-column align-items-center")
        b-skeleton(height="30vh" width="100%" class="my-2")
        b-skeleton(height="5vh" width="100%" class="my-2")
        b-skeleton(height="15vh" width="100%" class="my-2")
    div(v-if="error" class="d-flex w-100 h-100 flex-column align-items-center")
        lottie-animation(:animation-data="animationData" :autoPlay="true" :loop="true" :speed="1" ref="anim"  class="w-100")
        p(class="text-danger text-center") Its not you, its us. Something went wrong. Please try again later.
        b-button(@click="loadAnnouncement" variant="primary" class="mt-2") Try Again
                
                
            
</template>


<script>
import PinnedAnnouncement from "@/components/PinnedAnnouncement.vue";
import axios from "axios";
import errorAnimation from "@/assets/errorAnimation.json";
import LottieAnimation from 'lottie-web-vue'
import { clearBadge } from '@/utils/appBadge';
    export default {
        components: {
            PinnedAnnouncement,
            LottieAnimation
        },
        data() {
            return {
                animationData: errorAnimation,
                announcements: [],
                pinned: [],
                showModal: false,
                selectedAnnouncement: {
                    crb5c_title: "",
                    crb5c_body: "",
                    createdon: "",
                },
                showSubscriptionModal: false,
                selectedSubscription: null,
                acknowledging: false,
                loading: false,
                selectedMonth: this.$root.dayjs().format("YYYY-MM"),
                reloading: false,
                error: false,
                tcAcknowledgement: false,
                sendEmailCopy: false,
                recipientEmail: '',
                showEmailInputAfterAck: false,
                recipientEmailAfterAck: '',
                sendingEmailAfterAck: false,
            };
        },
        computed: {
            caregiverEmail() {
                return this.$store.state?.caregiver?.email || '';
            },
            emailValidation() {
                if (!this.sendEmailCopy || !this.recipientEmail) return null;
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailRegex.test(this.recipientEmail);
            },
            isValidEmail() {
                if (!this.sendEmailCopy) return true;
                if (this.caregiverEmail && !this.recipientEmail) return true;
                return this.emailValidation === true;
            },
            emailValidationAfterAck() {
                if (!this.recipientEmailAfterAck) return null;
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailRegex.test(this.recipientEmailAfterAck);
            },
            isValidEmailAfterAck() {
                if (this.caregiverEmail && !this.recipientEmailAfterAck) return true;
                return this.emailValidationAfterAck === true;
            }
        },
        async mounted() {
            this.loadAnnouncement();
            // Viewing notifications clears the unread badge (OS icon + in-app bubble).
            clearBadge();
            this.$store.commit('setUnreadNotifications', 0);
        },
        methods: {
            truncateText(html, length) {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                const text = tempDiv.textContent || tempDiv.innerText || '';
                if (text.length > length) {
                
                    return text.substring(0, length) + "...";
                } else {
                
                    return html;
                }
            },
            processAnnouncementBody(body) {
                if (!body) return '';

                let parsedBody = JSON.parse(body);

                const clientId = this.$root.currentUser[0]?.crb5c_client?.crb5c_fow_customerid;

                if (!clientId) return parsedBody;

                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = parsedBody;

                const links = tempDiv.querySelectorAll('a[href*="https://dsg-form.pages.dev/"]');

                links.forEach(link => {
                    const url = new URL(link.href);
                    url.searchParams.set('client_id', clientId);
                    link.href = url.toString();
                });

                return tempDiv.innerHTML;
            },

            async saveToDevice(url) {
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'image.jpg');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            async loadAnnouncement(){
                this.loading = true;
                this.error = false;
            try{
            await this.loadCurrentUser();
            if (this.$root.currentUser[0]?.crb5c_client?.crb5c_fow_customerid) {
            const {data} = await axios.get(`/api/announcements/v2`,{
                params: { userID: this.$root.currentUser[0].crb5c_client.crb5c_fow_customerid }
            });
            let {pinned,general} = data;
            this.announcements = general;
            this.pinned = pinned;
            }
            }catch(err){
                console.log(err);
                this.error = true;               
            }finally{
                this.loading = false;
            }
            },
            async monthsSelected() {
                this.reloading = true;
                try {
                    if (this.$root.currentUser[0]?.crb5c_client?.crb5c_fow_customerid) {
                        
                        const {data} = await axios.get(`/api/announcements/v2`,{
                            params: { userID: this.$root.currentUser[0].crb5c_client.crb5c_fow_customerid, date: this.selectedMonth }
                        });
                        let { pinned, general } = data;
                        this.announcements = general;
                        this.pinned = pinned;
                    }
                } catch (err) {
                    console.log(err);
                } finally {
                    this.reloading = false;
                }
            },
            async loadCurrentUser() {
            while (!this.$root.currentUser[0]) {
                await new Promise((resolve) => setTimeout(resolve, 1000));
            }
        },
            handleReadMore(announcement) {
                if (announcement.subscriptionData?.type === 'acknowledgment_required') {
                    this.openSubscriptionModal(announcement);

                } else {
                   
                    this.showModalAnnouncement(announcement);
                }
            },
            showModalAnnouncement(announcement){
                // console.log(announcement);
                this.selectedAnnouncement = announcement;
                // console.log(this.selectedAnnouncement);
                this.showModal = true;
            },
            openSubscriptionModal(announcement) {
                this.tcAcknowledgement = false;
                this.sendEmailCopy = false;
                this.recipientEmail = '';
                this.showEmailInputAfterAck = false;
                this.recipientEmailAfterAck = '';
                this.sendingEmailAfterAck = false;
                this.selectedSubscription = announcement;
                this.showSubscriptionModal = true;
            },
            closeSubscriptionModal() {
                this.showSubscriptionModal = false;
                this.selectedSubscription = null;
                this.acknowledging = false;
                this.tcAcknowledgement = false;
                this.sendEmailCopy = false;
                this.recipientEmail = '';
                this.showEmailInputAfterAck = false;
                this.recipientEmailAfterAck = '';
                this.sendingEmailAfterAck = false;
            },
            formatDate(dateString) {
                return new Date(dateString).toLocaleDateString("en-GB");
            },
            async acknowledgeSubscription() {
                this.acknowledging = true;
                try {
                    const payload = {
                        crb5c_userid: this.$root.currentUser[0].crb5c_client.crb5c_fow_customerid,
                        subscriptionId: this.selectedSubscription?.subscriptionData?.originalSubscriptionId
                    };
                    
                    const response = await axios.post('/api/subscriptions/subscribe', payload);
                    console.log('Successfully acknowledged:', response.data);
                    
                    if (this.sendEmailCopy) {
                        await this.sendAcknowledgementEmail();
                    }
                    
                    this.$bvToast.toast('Successfully acknowledged!', {
                        title: 'Acknowledgment',
                        variant: 'success',
                        solid: true
                    });
                    
                    await this.loadAnnouncement();
                    
                    this.closeSubscriptionModal();
                    
                } catch (error) {
                    console.error('Error acknowledging:', error);
                    this.$bvToast.toast('Error processing acknowledgment. Please try again.', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                } finally {
                    this.acknowledging = false;
                    this.tcAcknowledgement = false;
                }
            },
            async sendAcknowledgementEmail() {
                try {
                    const recipient = this.recipientEmail || this.caregiverEmail;
                    
                    if (!recipient) {
                        throw new Error('No email address provided');
                    }
                    
                    const payload = {
                        to: recipient,
                        subject: this.selectedSubscription?.crb5c_title,
                        body: this.selectedSubscription?.crb5c_body,
                        caregiverName: this.$store.state?.caregiver?.name,
                        acknowledgedAt: new Date().toISOString()
                    };
                    
                    await axios.post('/api/subscriptions/send-acknowledgement-email', payload);
                    
                    this.$bvToast.toast('Copy sent to email!', {
                        title: 'Email Sent',
                        variant: 'success',
                        solid: true
                    });
                } catch (error) {
                    console.error('Error sending email:', error);
                    this.$bvToast.toast('Failed to send email. Acknowledgement was still recorded.', {
                        title: 'Email Warning',
                        variant: 'warning',
                        solid: true
                    });
                }
            },
            cancelEmailAfterAck() {
                this.showEmailInputAfterAck = false;
                this.recipientEmailAfterAck = '';
            },
            async sendEmailAfterAcknowledgement() {
                this.sendingEmailAfterAck = true;
                try {
                    const recipient = this.recipientEmailAfterAck || this.caregiverEmail;
                    
                    if (!recipient) {
                        throw new Error('No email address provided');
                    }
                    
                    const payload = {
                        to: recipient,
                        subject: this.selectedSubscription?.crb5c_title,
                        body: this.selectedSubscription?.crb5c_body,
                        caregiverName: this.$store.state?.caregiver?.name,
                        acknowledgedAt: new Date().toISOString()
                    };
                    
                    await axios.post('/api/subscriptions/send-acknowledgement-email', payload);
                    
                    this.$bvToast.toast('Copy sent to email!', {
                        title: 'Email Sent',
                        variant: 'success',
                        solid: true
                    });
                    
                    this.showEmailInputAfterAck = false;
                    this.recipientEmailAfterAck = '';
                } catch (error) {
                    console.error('Error sending email:', error);
                    this.$bvToast.toast('Failed to send email. Please try again.', {
                        title: 'Email Error',
                        variant: 'danger',
                        solid: true
                    });
                } finally {
                    this.sendingEmailAfterAck = false;
                }
            },
            // truncateText(text, length) {
            //     if (text.length > length) {
            //         return text.substring(0, length) + "...";
            //     } else {
            //         return text;
            //     }
            // },
        },

    }
</script>

<style lang="scss" scoped>
.pinned-button{
    width: 100%;
    height: 10vh;
    background-color: #8967b3;
    outline: none;
    border: none;
    border-radius: 10px;
}
.pinned-active-button{
    border-radius: 10px 10px 0px 0px;
}
@keyframes icon-fade {
    0% {
        opacity: 0;
        transform: scaleY(0);
    }
    100% {
        opacity: 1;
        transform: scaleY(1);
    }
}
@keyframes icon-fade-up {
    0% {
        opacity: 0;
        transform: scaleY(0);
    }
    100% {
        opacity: 1;
        transform: scaleY(1);
    }
}
.pinned-announcement {
    background-color: #8967b3;
    border-radius: 0px 0px 10px 10px;
    padding: 1rem;
    gap: 1rem;
    animation: icon-fade 0.5s ease-in-out;
    transform-origin: top;
}
.fade-up{
    animation: icon-fade-up 0.5s ease-in-out;
    transform-origin: top;
}
.date-announcement{
    font-size: smaller;
}
.view-more{
    color:#8967b3;
    width: fit-content;
    border-bottom: 1px solid #8967b3;
    font-size: smaller;
}

.bi-chevron-right{
    color: #8967b3;
}
.card-announcement{
    border: 0.5px solid #8967b3;
    border-radius: 10px;
    
    
}
.spinner-border{
    //color #8967b3

    border: 0.15rem dashed #8967b3;
}
.title-name{
    font-weight: 600;
}
.form-input-month{
    width: 50%;
    height: 5vh;
    border: 1px solid #8967b3;
    border-radius: 10px;
}
.image-gallery-container{
    gap: 1rem;
    .img-cont{
        width: 100%;
        position: relative;
        
        img{
            border-radius: 10px;
            border: 1px solid #8967b3;
        }
        button{
            position: absolute;
            bottom: 0;
            right: 0;
        }

    }
}



.acknowledged-status {
    background: #d1fae5;
    padding: 0.75rem 1rem;
    border-radius: 8px;
    border: 1px solid #10b981;
}


.subscription-modal {
    overflow: hidden;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.modal-header-custom {
    background: linear-gradient(135deg, #52256B 0%, #764ba2 100%);
    color: white;
    padding: 1.5rem;
    
    .subscription-icon-large {
        width: 60px;
        height: 60px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 12px;
        color: white;
        backdrop-filter: blur(10px);
    }
    
    .btn-close-custom {
        background: rgba(255, 255, 255, 0.2);
        border: none;
        color: white;
        border-radius: 8px;
        
        &:hover {
            background: rgba(255, 255, 255, 0.3);
        }
    }
}

.modal-body-custom {
    padding: 1rem;
    background: #fafafa;
}

.description-section {
    background: white;
    padding: 1rem;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
}

.details-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
}

.detail-item {
    background: white;
    padding: 1.25rem;
    border-radius: 12px;
    display: flex;
    align-items: center;
    border: 1px solid #e5e7eb;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
    
    .detail-icon {
        width: 40px;
        height: 40px;
        background: #f8fafc;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.75rem;
    }
    
    .detail-label {
        font-size: 0.875rem;
        color: #6b7280;
        margin-bottom: 0.25rem;
    }
    
    .detail-value {
        font-weight: 600;
        color: #1f2937;
        font-size: 1rem;
    }
}

.modal-footer-custom {
    padding: 1.5rem;
    background: white;
    border-top: 1px solid #e5e7eb;
    display: flex;
    gap: 0.75rem;
    display: flex;
    justify-content: flex-end;
    
    .btn {
        border-radius: 8px;
        padding: 0.75rem 1.5rem;
        font-weight: 600;
        
        &.btn-primary {
            background: linear-gradient(135deg, #52256B 0%, #764ba2 100%);
            border: none;
            
            &:hover {
                background: linear-gradient(135deg, #441f5a 0%, #654991 100%);
            }
        }
    }
    
    .status-indicator {
        background-color: #28a745;
        color: white;
        padding: 2px 8px;
        border-radius: 10px;
        font-size: 0.8em;
    }
}

::v-deep a {
    color: #007bff;
    font-weight: bold;
    text-decoration: underline;
}
</style>